import { render, staticRenderFns } from "./KpiHead.vue?vue&type=template&id=6a9f2a26&scoped=true&"
import script from "./KpiHead.vue?vue&type=script&lang=js&"
export * from "./KpiHead.vue?vue&type=script&lang=js&"
import style0 from "./KpiHead.vue?vue&type=style&index=0&id=6a9f2a26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9f2a26",
  null
  
)

export default component.exports